
<template>
<th :style="columnStyles" @click="() => {
      $emit('click')
      sort()
    }" :class="sortableClass">
  <slot><span @click="$emit('clicked')" :class="labelClass">{{ label || id }}</span></slot>
  <span class="datatable-sort-arrow" :class="sortArrowClass" v-show="sorting"></span>
</th>
</template>

<script>
/* eslint-disable */

import _ from 'lodash'

const alignments = [
  "left",
  "center",
  "right",
  "auto"
];

const sortClassMap = {
  "1": "up",
  "-1": "down"
};

export default {
  name: "app-datatable-column",
  props: {

    id: {
      type: String,
      required: true
    },

    label: {
      type: String
    },

    labelClass: {
      type: String,
      default: null
    },

    width: {
      type: [ Number, String ]
    },

    alignment: {
      type: String,
      default: "left",
      validator: value => {
        return alignments.indexOf(value) > -1;
      }
    },

    formatter: {
      type: Function
    },

    sortable: {
      type: Boolean,
      default: true
    },

    searchable: {
      type: Boolean,
      default: true
    },

    searchKey: {
      type: String,
    },

    sortKey: {
      type: String,
    },

  },

  data() {
    return {
      sortingDirection: 1
    };
  },

  computed: {

    sorting: {
      get() {
        return (this.$parent.sortingId === this.id && this.sortable);
      },
      set(value) {
        if (value && this.sortable) {
          this.$parent.sortingId = this.id;
        }
      }
    },

    columnWidth() {
      if (!this.width) {
        return;
      }

      let suffix = isNaN(this.width) ? "" : "%";

      return this.width + suffix;
    },

    columnStyles() {
      return {
        width: this.columnWidth,
        textAlign: this.alignment
      };
    },

    sortArrowClass() {
      let direction = sortClassMap[this.sortingDirection];
      return "fas fa-caret-" + direction;
    },

    sortableClass() {
      if ( this.sortable ) {
        return "sortable";
      }

      return null;
    }

  },

  methods: {

    sort() {
      if (this.sorting) {
        this.sortingDirection *= -1;
        return;
      }

      this.sorting = true;
    },

    formatData(value) {
      if (!this.formatter) {
        return value;
      }

      return this.formatter(value);
    },

    isSearchable() {
      return this.searchable;
    },

    getSearchKey() {
      return this.searchKey || this.id;
    },

    getSortKey() {
      return this.sortKey || this.id;
    }

  },

  created() {
    let addColumn = this.$parent.addColumn;

    if (!addColumn) {
      console.warn("A datatable-column must be registered within an app-datatable component.");
      return;
    }

    addColumn(this);
  },

  destroyed() {
    this.$parent.removeColumn(this);
  }

}
</script>

<style lang="scss">
@import 'mixins';
@import 'variables_app_datatables.scss';
@import '../../style/variables';

.app-datatable {
    th {
        position:relative;
        &.sortable {
            cursor: pointer;
        }

        @include no-select();
    }

    .datatable-sort-arrow {
        @include vertical-align(absolute);
        margin-left: 3px;
        font-size: .875rem;
        color: $dark-purple;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Datatables/AppDatatableColumn.vue